/**
 * Created by Arif Topcu in 2019
 */

import { combineReducers } from "redux";
import app from "./app/reducer";
import data from "./data/reducer";
import selection from "./selections/reducer";
import grid from "state/grid/reducer";
import analyticsScope from "state/analytics/scope";
import bookAnalyticsScope from "state/bookAnalytics/scope";
import analyticsReducer from "state/analytics/reducer";
import bookAnalyticsReducer from "state/bookAnalytics/reducer";
import betasScope from "state/betas/scope";
import betasReducer from "state/betas/reducer";
import securityAttributesScope from "state/securityAttributes/scope";
import securityAttributesReducer from "state/securityAttributes/reducer";
import teScope from "state/trackingError/scope";
import teReducer from "state/trackingError/reducer";
import fatScope from "state/factorAttribution/scope";
import fatReducer from "state/factorAttribution/reducer";
import issueCountScope from "state/issueCount/scope";
import issueCountReducer from "state/issueCount/reducer";
import issuerCountScope from "state/issuerCount/scope";
import issuerCountReducer from "state/issuerCount/reducer";
import traceAnalyticsScope from "state/traceAnalytics/scope";
import traceAnalyticsReducer from "state/traceAnalytics/reducer";
import ratingsScope from "state/ratings/scope";
import ratingsReducer from "state/ratings/reducer";
import scenario from "./scenario/reducer";
import scenarioAnalysis from "./scenarioAnalysis/reducer";
import scane2Scope from "state/scan2/scope";
import scan2Reducer from "./scan2/reducer";

export default combineReducers({
  app,
  data,
  scenario,
  scenarioAnalysis,
  selection,
  grid,
  [analyticsScope]: analyticsReducer,
  [bookAnalyticsScope]: bookAnalyticsReducer,
  [betasScope]: betasReducer,
  [issueCountScope]: issueCountReducer,
  [issuerCountScope]: issuerCountReducer,
  [securityAttributesScope]: securityAttributesReducer,
  [teScope]: teReducer,
  [teScope]: teReducer,
  [fatScope]: fatReducer,
  [traceAnalyticsScope]: traceAnalyticsReducer,
  [ratingsScope]: ratingsReducer,
  [scane2Scope]: scan2Reducer,
});
